var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-button',{staticClass:"theme-switch",on:{"click":_vm.handleButtonClick}},[_c('app-icon',{class:_vm.sunIconClassName,attrs:{"value":"icon-sun"}}),_c('app-icon',{class:_vm.moonIconClassName,attrs:{"value":"icon-moon"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }